function initProductModal() {
  const modal = document.querySelector(".elem__card-product-modal");
  if (!modal) return;

  const modalContent = modal.querySelector(".elem__card-product-modal-content");
  const modalTop = modal.querySelector(".product__modal--top");
  const modalImage = modal.querySelector(".product__modal--top .elem__card-product__image");
  const modalTag = modal.querySelector(".product__modal--top .elem__card-product__tag");
  const modalTitle = modal.querySelector(".product__modal--main .content__title");
  const modalRich = modal.querySelector(".product__modal--main .content__rich--card");
  const modalCta = modal.querySelector(".product__modal--main .utility__border-wrap a[href]");

  if (!modalContent || !modalTop || !modalImage || !modalTag || !modalTitle || !modalRich) {
    return;
  }

  const ctaTemplate = modalCta?.getAttribute("href") || "/contact-us?product={slug}";
  const PRODUCT_HISTORY_KEY = "modernexpoProductSlug";
  let lockedScrollY = null;
  let htmlOverflow = "";
  let bodyOverflow = "";
  const getText = (element) => (element?.textContent || "").trim();
  const getBackgroundColor = (element) =>
    element ? window.getComputedStyle(element).backgroundColor : "";
  const setAttribute = (element, name, value) => {
    if (value) {
      element.setAttribute(name, value);
    } else {
      element.removeAttribute(name);
    }
  };

  function getProductBasePath() {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const productsIndex = pathSegments.lastIndexOf("products");

    if (productsIndex === -1) return "/products";

    return `/${pathSegments.slice(0, productsIndex + 1).join("/")}`;
  }

  function getProductSlugFromLocation() {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    const productsIndex = pathSegments.lastIndexOf("products");
    const encodedSlug = productsIndex >= 0 ? pathSegments[productsIndex + 1] : "";

    if (!encodedSlug) return "";

    try {
      return decodeURIComponent(encodedSlug);
    } catch {
      return encodedSlug;
    }
  }

  function buildProductUrl(slug) {
    const url = new URL(window.location.href);
    const basePath = getProductBasePath();

    url.pathname = slug ? `${basePath}/${encodeURIComponent(slug)}` : basePath;

    return `${url.pathname}${url.search}${url.hash}`;
  }

  function createHistoryState(slug) {
    return Object.assign({}, window.history.state, {
      [PRODUCT_HISTORY_KEY]: slug || null,
    });
  }

  function lockPageScroll() {
    if (lockedScrollY !== null) return;

    lockedScrollY = window.scrollY;
    htmlOverflow = document.documentElement.style.overflow;
    bodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  function unlockPageScroll() {
    if (lockedScrollY === null) return;

    const scrollY = lockedScrollY;
    lockedScrollY = null;
    document.documentElement.style.overflow = htmlOverflow;
    document.body.style.overflow = bodyOverflow;
    window.requestAnimationFrame(() => {
      window.scrollTo(0, scrollY);
    });
  }

  function getCardSlug(card) {
    return getText(card?.querySelector(".elem__card-product--modal-slug"));
  }

  function findProductCard(slug) {
    return (
      Array.from(document.querySelectorAll(".elem__card-product--wrap")).find(
        (card) => getCardSlug(card) === slug
      ) || null
    );
  }

  function buildHref(slug) {
    if (ctaTemplate.includes("{slug}")) {
      return ctaTemplate.replace(/\{slug\}/g, encodeURIComponent(slug || ""));
    }

    const url = new URL(ctaTemplate, window.location.origin);

    if (slug) {
      url.searchParams.set("product", slug);
    } else {
      url.searchParams.delete("product");
    }

    return `${url.pathname}${url.search}${url.hash}`;
  }

  function syncImage(sourceImage, fallbackAlt) {
    setAttribute(modalImage, "src", sourceImage?.getAttribute("src"));
    setAttribute(modalImage, "srcset", sourceImage?.getAttribute("srcset"));
    setAttribute(modalImage, "sizes", sourceImage?.getAttribute("sizes"));
    modalImage.alt = sourceImage?.getAttribute("alt") || fallbackAlt || "";
  }

  function openModal(card, { updateHistory = true } = {}) {
    const cardSurface = card.querySelector(".elem__card-product");
    const cardTag = card.querySelector(".elem__card-product__tag");
    const cardTitle = card.querySelector(
      '.elem__card-product__bottom [data-wf--types--variant="cta"], .elem__card-product__bottom .elem__types'
    );
    const cardImage = card.querySelector(
      ".elem__card-product > .elem__card-product__image, .elem__card-product__image"
    );
    const richSource = card.querySelector(".elem__card-product--modal-rich");
    const slugSource = card.querySelector(".elem__card-product--modal-slug");

    const slug = getText(slugSource);
    const title = getText(cardTitle);

    modalTop.style.backgroundColor = getBackgroundColor(cardSurface);
    modalTag.style.backgroundColor = getBackgroundColor(cardTag);
    modalTag.textContent = getText(cardTag);
    modalTitle.textContent = title;
    modalRich.innerHTML = richSource?.innerHTML || "";
    syncImage(cardImage, title);

    if (modalCta) {
      modalCta.setAttribute("href", buildHref(slug));
    }

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    modalContent.scrollTop = 0;
    lockPageScroll();

    if (updateHistory && slug) {
      const nextUrl = buildProductUrl(slug);
      const currentSlug = getProductSlugFromLocation();

      if (currentSlug === slug) {
        window.history.replaceState(createHistoryState(slug), "", nextUrl);
      } else {
        window.history.pushState(createHistoryState(slug), "", nextUrl);
      }
    }
  }

  function closeModal({ updateHistory = true } = {}) {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");

    const currentSlug = getProductSlugFromLocation();
    if (!updateHistory || !currentSlug) {
      unlockPageScroll();
      return;
    }

    if (window.history.state?.[PRODUCT_HISTORY_KEY] === currentSlug) {
      window.history.back();
      return;
    }

    window.history.replaceState(createHistoryState(""), "", buildProductUrl(""));
    unlockPageScroll();
  }

  function syncModalWithLocation({ initializeHistory = false } = {}) {
    const slug = getProductSlugFromLocation();

    if (!slug) {
      closeModal({ updateHistory: false });
      return;
    }

    const card = findProductCard(slug);
    if (!card) return;

    if (initializeHistory && window.history.state?.[PRODUCT_HISTORY_KEY] !== slug) {
      const productUrl = buildProductUrl(slug);

      window.history.replaceState(createHistoryState(""), "", buildProductUrl(""));
      window.history.pushState(createHistoryState(slug), "", productUrl);
    }

    window.requestAnimationFrame(() => {
      if (getProductSlugFromLocation() !== slug) return;

      card.scrollIntoView({ block: "center" });
      openModal(card, { updateHistory: false });
    });
  }

  document.addEventListener("click", (event) => {
    const closeTrigger = event.target.closest(
      ".product__modal--close, .elem__card-product-overlay"
    );

    if (closeTrigger && modal.contains(closeTrigger)) {
      event.preventDefault();
      closeModal();
      return;
    }

    const card = event.target.closest(".elem__card-product--wrap");
    if (!card) return;

    event.preventDefault();
    openModal(card);
  });

  document.addEventListener("keydown", (event) => {
    const isEscape = event.key === "Escape" || event.keyCode === 27;

    if (isEscape && modal.classList.contains("is-open")) {
      closeModal();
    }
  });

  window.addEventListener("popstate", () => {
    syncModalWithLocation();
  });

  syncModalWithLocation({ initializeHistory: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductModal);
} else {
  initProductModal();
}
